import { CloseOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { AdminTableFooter, InputSearch, Table } from "../../../components";
import { COLORS } from "../../../constants";
import { CAContext } from "../../../types";
import { CoeffAdminContext } from "../CoeffAdmin";

const Wrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledInputSearch = styled(InputSearch)`
  width: 100%;
  max-width: 360px;
  margin-right: 8px;
`;

const StyledCloseOutlined = styled(CloseOutlined)`
  color: ${COLORS.black85};
  font-size: 9px;
`;

export const Domains = () => {
  const { loading, domains, selectDomain, getDomains } = useContext(CoeffAdminContext) as CAContext;

  const [searchValue, setSearchValue] = useState<string>("");

  const [page, setPage] = React.useState(0);

  const defaultPageSize = 100;

  const [offset, setOffset] = React.useState<number>(0);

  const setPageAndOffset = (page: number) => {
    setPage(page);

    setOffset(page * defaultPageSize);
  };

  useEffect(() => {
    const params = {
      search_by: searchValue,
      offset: offset,
      page_size: defaultPageSize,
    };
    getDomains(params);
  }, [page, offset]);

  const columns = [
    {
      title: "Domain",
      dataIndex: "domain",
      key: "domain",
      width: 200,
      showSorterTooltip: false,
      render: (domain: string) => (
        <Link
          to={`/superadmin/domainDetails?domain=${domain}`}
          onClick={() => selectDomain(domain)}
        >
          {domain}
        </Link>
      ),
    },
    {
      title: "Domain Family",
      dataIndex: "domain_family",
      key: "domain_family",
      width: 120,
      showSorterTooltip: false,
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 120,
      showSorterTooltip: false,
      sorter: (a, b) => a.created_date - b.created_date,
    },
  ];

  const dataSource = domains.map(domain => ({
    key: domain.domain,
    domain: domain.domain,

    domain_family: domain.domain_family,
    created_date: domain.created_date,
  }));

  const total_domains = (domains?.length > 0 ? domains[0].total_domains : undefined) ?? 0;

  const locale = {
    emptyText: "No Domains",
  };

  const handleEnter = (e, searchValue) => {
    if (e.key === "Enter") {
      setSearchValue(searchValue);
      setPageAndOffset(0);
      const params = {
        search_by: searchValue,
        offset: offset,
        page_size: defaultPageSize,
      };
      getDomains(params);
    }
  };

  const handleClear = () => {
    setSearchValue("");
    setPageAndOffset(0);
    const params = {
      offset: offset,
      page_size: defaultPageSize,
    };
    getDomains(params);
  };

  return (
    <Wrapper>
      <div style={{ flex: "1" }}>
        <StyledInputSearch
          onKeyUp={e => handleEnter(e, searchValue)}
          onChange={e => setSearchValue(e.target.value)}
          allowClear={{
            clearIcon: <StyledCloseOutlined onClick={handleClear} />,
          }}
          value={searchValue}
        />
      </div>

      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        locale={locale}
        pagination={false}
        scroll={{ x: "auto", y: "auto" }}
      />

      <AdminTableFooter
        page={page}
        pageSize={defaultPageSize}
        onPageChange={page => setPageAndOffset(page)}
        data={dataSource.map(x => [x.domain ?? "", true])}
        totalRowCount={total_domains}
      />
    </Wrapper>
  );
};
